import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {CheckIcon, ThinTimeIcon} from "../../../components/icons/material-icons";
import {Link} from "react-router-dom";

export interface staffAttendAbsents{
    id:number,
    name:string,
    tell:string,
    job:string,
    inside:boolean,
}

export const AdminsStaffAttendAbsentsScreen = () => {
    const [loaded,setLoaded] = useState(false);
    const [list,setList] = useState<staffAttendAbsents[]>([]);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/attend/absents',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: staffAttendAbsents[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "لیست حضور | منابع انسانی | اتوماسیون";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/attend', title: 'حضورغیاب'},
                {url: '/admins/staff/attend/list', title: 'لیست حضور'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>لیست حضورغیاب</b>
                            </div>
                            <table className="table open-table table-striped table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>همکار</th>
                                    <th>شغل</th>
                                    <th>تلفن</th>
                                    <th>وضعیت</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((p, i) =>
                                        <tr key={"Dx3s3J_Sx" + i}>
                                            <td style={{width: '10%'}}>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td><Link to={`/admins/staff/view/${p.id}`}>{p.name}</Link></td>
                                            <td>{p.job === '' ? '-' : p.job}</td>
                                            <td>{StringDigitsConvertToPersian(p.tell.replaceAll('+98','0'))}</td>
                                            <td style={{width: '25%'}}>
                                                <em data-color={p.inside ? 'green' : 'red'}>
                                                    {p.inside ? <CheckIcon/> : <ThinTimeIcon/>}
                                                    {p.inside ? 'حاضر' : 'غایب'}
                                                </em>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> :
                    null
            }
        </>
    );
};